import { render, staticRenderFns } from "./BrokerProposalFillPage.vue?vue&type=template&id=71ca24fc&scoped=true&"
import script from "./BrokerProposalFillPage.vue?vue&type=script&lang=js&"
export * from "./BrokerProposalFillPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ca24fc",
  null
  
)

export default component.exports